import { useEffect } from 'react';

import { setToken } from '@/utils/common/storage';
import isApp from '@/utils/ua';

import { useUserProfile } from './useUserProfile';

const useAppProfile = (params?: {
  successCallback: () => void;
  failCallback: () => void;
}) => {
  const { updateUserProfile } = useUserProfile();
  const { successCallback, failCallback } = params || {};

  useEffect(() => {
    if (isApp()) {
      const fn = async () => {
        const { default: Hecate } = await import('@bybit/hecate');
        await Hecate.ready();
        Hecate.ready().then(() => {
          Hecate?.UserProfile?.getUserProfile({
            needLogin: true,
            forceUpdate: true,
          })
            .then((res: any) => {
              const token = res.params ? res.params.userToken : '';
              if (token) {
                setToken(token);
                updateUserProfile();
                successCallback?.();
              }
            })
            .catch((error: any) => {
              failCallback?.();
              console.log('app登陆态获取失败', error);
            });
        });
      };
      fn();
    }
  }, []);
};

export default useAppProfile;
